import { globalTranslations } from '@futures-platform/i18n'
import {
  getAccountLanguage,
  initTranslations,
  setLanguage,
} from '@futures-platform/i18n'

export const localTranslations = {
  opportunitiesCommentSection: {
    en: 'Opportunities',
    fi: 'Mahdollisuudet',
  },
  threatsCommentSection: {
    en: 'Threats',
    fi: 'Uhat',
  },
  actionsCommentSection: {
    en: 'Actions',
    fi: 'Toimenpiteet',
  },

  commentViewBtn: {
    en: 'Comment / View',
    fi: 'Kommentoi / Näytä',
  },
  latestNewsTitle: {
    en: 'Latest News',
    fi: 'Tuoreet uutiset (engl.)',
  },
  clearRatings: {
    en: 'Clear Ratings',
    fi: 'Tyhjennä',
  },
  relatedPhenomenaSection: {
    en: 'Related phenomena',
    fi: 'Liittyvät ilmiöt',
  },
  charactersRemainingText: {
    en: 'characters remaining',
    fi: 'merkkiä jäljellä',
  },
  submitCommentModal: {
    en: 'SUBMIT',
    fi: 'LÄHETÄ',
  },
  editCommentTitle: {
    en: 'Edit Comment',
    fi: 'Muokkaa kommenttia',
  },
  cancel: {
    en: 'CANCEL',
    fi: 'PERUUTA',
  },
  save: {
    en: 'SAVE',
    fi: 'TALLENNA',
  },
  removeComment: {
    en: 'REMOVE COMMENT',
    fi: 'POISTA KOMMENTTI',
  },
  removeCommentConfirmation: {
    en: 'Are you sure you want to remove your comment?',
    fi: 'Haluatko varmasti poistaa kommenttisi?',
  },
  removeCommentNoOption: {
    en: 'NO, KEEP IT',
    fi: 'EN SITTENKÄÄN',
  },
  removeCommentYesOption: {
    en: 'YES',
    fi: 'KYLLÄ',
  },
  editPhenomenon: {
    en: 'Edit Phenomenon',
    fi: 'Muokkaa ilmiötä',
  },
  editted: {
    en: 'Edited',
    fi: 'Päivitetty',
  },
  Links: {
    en: 'Links',
    fi: 'Linkit',
  },
  yes: {
    en: `Yes`,
    fi: `Kyllä`,
  },
  editHistory: {
    en: `Edit history`,
    fi: `Muokkaa historiaa`,
  },
  editOn: {
    en: `Edited on`,
    fi: `Muokattu`,
  },
  by: {
    en: `by`,
    fi: `-`,
  },
  Description: {
    en: `Description`,
    fi: `Kuvaus`,
  },
  Removeevent: {
    en: `Remove event`,
    fi: `Poista tapahtuma`,
  },
  RemoveeventText: {
    en: `Are you sure you want to remove this event permanently from the change log?`,
    fi: `Haluatko varmasti poistaa tämän tapahtuman aikajanalta pysyvästi?`,
  },
  DescriptionMajorChangeLogs: {
    en: `Description for major update`,
    fi: `Description for major update`,
  },
  ShowAsMajorUpdate: {
    en: `Show as major update`,
    fi: `Show as major update`,
  },
  Historyandchangelog: {
    en: 'History and change log',
    fi: `History and change log`,
  },
  ShowHistory: {
    en: 'Show history',
    fi: `Show history`,
  },
  HideHistory: {
    en: 'Hide history',
    fi: `Hide history`,
  },
  createdby: {
    en: `Created on`,
    fi: `Luotu`,
  },
  relatedScenario: {
    en: 'Related scenarios',
    fi: `Liittyvät skenaariot`,
  },
  Created: {
    en: 'Created',
    fi: `Luotu`,
  },
  Edited: {
    en: 'Edited',
    fi: `Muokattu`,
  },
  lastModified: {
    en: 'Last modified',
    fi: `Päivitetty`,
  },
  on: {
    en: 'on',
    fi: `-`,
  },
  editingTextHistory: {
    en: 'Write here a brief description why this should be considered as major update.',
    fi: `Tähän voit listata, mitä merkittäviä muutoksia olet tehnyt sisältöön.`,
  },
  pdfExportTooltip: {
    en: 'Download as PDF',
    fi: 'Lataa PDF',
  },
}

export const finalTranslations = { ...globalTranslations, ...localTranslations }
initTranslations(localTranslations)
setLanguage(getAccountLanguage())
